// extracted by mini-css-extract-plugin
export default {"settingsItem":"VariationSettingsItem_settingsItem__Rb5ab"};